export const getListaTrabajos = (state) => {
  return state.listaTrabajos;
};

export const getProvincias = (state) => {
  return state.listaProvincias;
};

export const getPerfil = (state) => {
  return state.perfil;
};

export const getDraftsPropuestaDialog = (state) => {
  return state.draftsPropuestaDialog;
};
